ion-item-group {
  display: block;
}